<template>
    <div>
        <header>
            <img src="../assets/logo.svg">
            <router-link to="/">
                <div class="subtitle">
                    <span>{{brandName}}</span>
                    <span>  >  </span>
                    <span>{{area}}</span>
                    <span>  >  </span>
                </div>
            </router-link>
        </header>

        <div class="content" :style="height">
            <iframe :src="link"></iframe>
            <div class="seclect seclect-fourth">
                <h2>Which media channels you want to select?</h2>
                <p class="third-sub">请基于预算选择投放户外媒体。（剩余预算将全部用于基于LBS Digital的数字广告投放。） <span>Please select OOH media  based on your budget. (The rest of your budget will be spent on LBS digital ads.) </span>
                </p>
                <p class="third-sub four-sub"><span>投放时间time duration：<b>1个月</b></span><span>预算 budget: <b>1000万</b></span><span>Remain budget for LBS digital ad: <b>{{money}} RMB</b></span>
                </p>
                <div class="brand">

                    <div class="radioBox" v-for="(item,index) in radioVal">
                        <input @click="changeColor(index)" type="checkbox" :id="'checkbox_b'+index"
                               class="checkboxCircular" :value="item.val" v-model="picked"
                               :disabled="item.val == 'Lbs'"/><label clickMusic='true'
                            :for="'checkbox_b'+index"></label>
                                                        <label clickMusic='true' v-if="index == 3"  :for="'checkbox_b'+index">{{item.text}}</label>
                            <label clickMusic='true' v-else :for="'checkbox_b'+index">{{item.text+'（'+channelNum[index]+'spots，'+item.budget+'）'}}</label>
                    </div>


                </div>
            </div>


        </div>
        <footer>
            <div>
                <div class="prev">
                    <router-link to="/third"> << prev </router-link>
                </div>
                <div class="step"><span>3/4</span></div>
                <div class="continue"><span><button clickMusic='true' @click="validate">Continue</button></span></div>
            </div>
        </footer>

        <alert v-if="show" @showbox="toshow" :show="show" :msg="msg"></alert>

    </div>

</template>
<style type="text/css">

    .content .seclect p.third-sub {
        padding: 0% 5% 2% 10%;
        font-size: 16px;
        color: #535b68
    }

    .content .seclect p.third-sub span {
        display: block;
        font-size: 12px;
        padding-top: 10px;
    }

    .content .seclect-fourth h2 {
        padding: 5% 5% 2% 10%;
        font-size: 36px;
    }

    .content .seclect p.four-sub span {
        font-size: 15px;
        color: #15eebd;
        display: block;
        font-weight: normal;
        line-height: 20px;
    }

    .radioBox {
        background: #ffffff;
        border-radius: 24px;
        padding: 2% 5%;
        width: 80%;
        margin: 5% 0;
        border: 1px solid #eee;
        color: #717780;
    }

    .checkboxCircular {
        display: none;
    }

    label{cursor: pointer;}

    .checkboxCircular + label {
        display: inline-block;
        margin-right: 5px;
        color: #FFF;
        font-size: 1.7em;
        content: ' ';
        border-radius: 5px;
        width: 20px;
        position: relative;
        height: 20px;
        vertical-align: text-bottom;
        border: 1px solid #eee;
    }

    .checkboxCircular + label:after {
        content: '\2714';
        font-size: 18px;
        width: 20px;
        position: relative;
        top: -3px;
        right: -3px;
        height: 20px;
        display: none;
    }

    .checkboxCircular:checked + label:after {
        display: block;

    }

    .checkboxCircular:checked + label {
        background: #004976;
        border-color: #fff;
        color: #fff
    }


</style>

<script>
    import Alert from './alert.vue';
    import link from '../assets/link';


    export default {
        name: "second",
        components: {
            "alert": Alert
        },
        data(){
            return {
                msg: "You must select one retail channel",
                brandName: "",
                link: '',
                area: '',
                areaNum:'',
                channelNum:'',
                show: false,
                money: '10,000,000',
                height: {
                    height: ""
                },
                picked: ["Lbs"],
                radioVal1: [
                    {text: "大卖场", val: "bigStore"},
                    {text: "便利店", val: "convenienceStore"},
                    {text: "屈臣氏", val: "Watsons"}
                ],
                radioVal: [
                    {text: "楼宇电视广告位", val: "building",budget:''},
                    {text: "公交站广告位", val: "transit",budget:''},
                    {text: "地铁站广告位", val: "metro",budget:''},
                    {text: "LBS Digital ", val: "Lbs"}
                ],
                budget:[],


            }
        },
        watch: {
            picked: function (val) {

                let money1 = 10000000;
                console.log(val)
                for (let h = 0; h < this.picked.length; h++) {
                    if (val[h] == "building") {
                        money1 = money1 - this.budget[0];
                    } else if (val[h] == "transit") {
                        money1 = money1 - this.budget[1];
                    } else if (val[h] == "metro") {
                        money1 = money1 - this.budget[2];

                    }
                }

                this.money =  this.numFormat(money1)
            }
        },
        methods: {

            toshow(show){
                this.show = show;
            },
            readData(){
                this.brandName = sessionStorage.getItem("BrandName");
                let area1 = sessionStorage.getItem("area");
                this.showLink();
                for (let x = 0; x< this.radioVal1.length;x++) {
                    if (this.radioVal1[x].val == area1) {
                        this.area = this.radioVal1[x].text
                    }
                }
                for(let y = 0 ;y<this.budget.length;y++){
                    this.radioVal[y].budget=this.numFormat(this.budget[y])+'RMB'
                }



            },
            showLink(){
                for (let a of link.brand) {
                    if (a.name == this.brandName) {
                        this.link = a.link[3]
                        this.areaNum =a.area[0]
                        this.channelNum =a.area[1]
                        this.budget=a.area[2]
                    }
                }
            },
            changeColor(index){
                var id = "checkbox_b" + index
                var g = document.getElementById(id);
                let x = document.getElementsByClassName('radioBox')[index]

                if (g.checked) {
                    if (this.picked.length >= 3) {
                        this.show = true
                        this.msg = "not enough budget!"
                        g.checked = false
                        x.style.background = "#fff";
                        x.lastChild.style.color = "#717780";

                    } else {
                        x.style.background = "#004976";
                        x.lastChild.style.color = "#fff";
                    }
                } else {
                    x.style.background = "#fff";
                    x.lastChild.style.color = "#717780";

                }


            },
            validate(){
                if (this.picked.length == 1) {
                    this.show = true
                    this.msg = "Please select at least one OOH media channel"
                } else if (this.picked.length == 4) {
                    this.show = true;
                    this.msg = "not enough budget!"
                } else {
                    this.show = false;
                    sessionStorage.setItem("channel", this.picked);
                    this.$router.push('fifth')
                }
            },
            numFormat(num){
                num = num.toString().split(".");
                var arr = num[0].split("").reverse();
                var res = [];
                for (var i = 0, len = arr.length; i < len; i++) {
                    if (i % 3 === 0 && i !== 0) {
                        res.push(",");
                    }
                    res.push(arr[i]);
                }
                res.reverse();
                if (num[1]) {
                    res = res.join("").concat("." + num[1]);
                } else {
                    res = res.join("");
                }
                return res;
            }

        },
        created() {
            this.height.height = window.innerHeight - 120 + 'px'
            this.readData();

        },
        mounted() {
            this.changeColor(3)
        }


    }

</script>



// WEBPACK FOOTER //
// src/components/fourth.vue